export { AnatomoService } from './anatomo/anatomo.service';
